<template>
  <div>
    <v-dialog/>
    <div class="admin_title">试题管理</div>
    <!--右侧内容-->
    <div class="gj_top_class_two">
      <input name="" type="button" class="btn_s_gj" />
      <input v-model="filter.title" type="text" class="put_gj" />
      <select v-model="filter.largeType" @change="getMiddleTypes(filter.largeType)">
        <option :value="''">(全部)大分类</option>
        <option v-for='item in largeTypes' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select v-model="filter.middleType">
        <option :value="''">(全部)小分类</option>
        <option v-for='item in middleTypes' :key="item.middleType" :value="item.middleType">{{item.middleTypeLabel}}</option>
      </select>
      <select v-model="filter.questionType">
        <option :value="''">(全部)题型</option>
        <option v-for='item in Dropdown.state.questionType' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <button class="watch ml18 mr40" style="cursor: pointer;" @click="searchByFilter(filter)">查询</button>
      <button class="excel_dao mr6" style="cursor: pointer;" @click="importQuestions">导入试题</button>
      <button class="excel_dao mr12" style="cursor: pointer;"><a :href="downloadLink">下载模板</a></button>
      <!--<button class="excels_dao">资源批量导入</button>-->
      <div class="dropdown">
        <span class="kaoshi_add">新增试题</span>
        <div class="dropdown-content">
          <li><a href="javascript:;" @click="editQuestion('', 'selection')">单选题</a></li>
          <li><a href="javascript:;" @click="editQuestion('', 'multiSelection')">多选题</a></li>
          <li><a href="javascript:;" @click="editQuestion('', 'write')">填空题</a></li>
          <li><a href="javascript:;" @click="editQuestion('', 'judgement')">判断题</a></li>
          <li><a href="javascript:;" @click="editQuestion('', 'short')">简答题</a></li>
        </div>
      </div>
    </div>
    <div style="padding-left: 10px;padding-right: 50px;background: #ffffff;margin-top: 24px; min-height: 500px;">
      <table id="customers" class="kaoti_customers">
        <tr>
          <th>试题名称</th>
          <th>试题类型</th>
          <th>试题分类</th>
          <th>操作</th>
        </tr>
        <tr v-for="item in list" :key="item.id">
          <td>{{item.title}}</td>
          <td>{{item.questionTypeLabel}}</td>
          <td>{{item.largeTypeLabel}}-{{item.middleTypeLabel}}</td>
          <td>
            <a href="javascript:;" class="red_font mr12" @click="editQuestion(item.id, item.questionType)">修改</a>
            <span v-if="item.isUsed != '0'">试题已使用</span>
            <a href="javascript:;" class="red_font" v-if="item.isUsed == '0'" @click="delQuestion(item.id)">删除</a>
          </td>
        </tr>
      </table>
      <h5 class="none_ts" v-if="questionCnt <= 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <div class="zy_list_bottom">
      <dl>
        <dt><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{questionCnt}}道试题</dt>
        <dd v-if="questionCnt>0">
          <paginate ref="paginate" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import Paginate from 'vuejs-paginate'
import s_query from '@/utils/s_query'
import { getCookie } from '@/store/cookies'
import api from '@/api/index'
import config from '@/config/index'
export default {
  components: { Paginate },
  data () {
    return {
      downloadLink: config.question_sheets,
      Dropdown: Dropdown,
      filter: {
        pageNo: 1,
        pageSize: this.$global.paginationOptions.page_num,
        largeType: '',
        middleType: '',
        questionType: '',
        title: ''
      },
      list: [],
      pages: 0,
      questionCnt: 0,
      largeTypes: [],
      middleTypes: [],
      prefix: this.$route.meta.prefix || ''
    }
  },
  created () {
    if (getCookie('query_record') && getCookie('query_record')[this.$route.path]) {
      this.filter = getCookie('query_record')[this.$route.path]
    }
    this.getQuestions(this.filter)
    this.getLargeTypes()
  },
  computed: {},
  methods: {
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: o.title,
        text: o.text,
        buttons: [
          {
            title: '确认',
            default: true,
            handler: that.$utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getQuestions(this.filter)
    },
    resetPagination () {
      this.filter.pageNo = 1
      if (this.$refs.paginate) {
        this.$refs.paginate.selected = 0 // 重置 active-class为第一页
      }
    },
    importQuestions () {
      var that = this
      this.confirmBox({
        title: '导入试题',
        text: '<input id="importQuestions" type="file">',
        yes: function () {
          var file = document.getElementById('importQuestions').files;
          if (file.length) {
            var isExcel = /\.(?:xls|xlsx)$/i.test(file[0].name);
            if (isExcel) {
              var o = {}
              o.file = file[0]
              var fd = new FormData()
              for (var key in o) {
                fd.append(key, o[key])
              }
              api.post(config.examApiPath, '/examQuestion/importQuestion', fd, function (r) { // 正常
                that.$toasted.show(r.message)
                setTimeout(function () {
                  that.getQuestions(that.filter)
                }, 0)
                that.$modal.hide('dialog')
              })
            } else {
              that.$toasted.show('只允许上传.xsl,.xslx格式的文件')
            }
          } else {
            that.$toasted.show('请选择文件')
          }
        }
      })
    },
    searchByFilter (filter) {
      this.resetPagination()
      this.getQuestions(filter)
    },
    getLargeTypes () {
      this.$api.post(this.$global.examApiPath, '/dict/get', {type: 'examLargeType'}, r => {
        this.largeTypes = r.data
      })
    },
    getMiddleTypes (largeType) {
      this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: largeType,  middleType: 'examMiddleType', select: '1'}, r => {
        this.middleTypes = r.data
        this.searchByFilter(this.filter)
      })
    },
    getQuestions (filter) {
      s_query.save(this.$route.path, filter)
      this.$api.post(this.$global.examApiPath, '/examQuestion/search', filter, r => {
        this.questionCnt = r.cntData
        this.pages = Math.ceil(r.cntData / this.$global.paginationOptions.page_num)
        this.list = r.data
        this.$nextTick(() => { // 数据初始化时分页组件需要手动更新
          if (this.$refs.paginate) {
            this.$refs.paginate.selected = this.filter.pageNo - 1
          }
        })
      })
    },
    editQuestion (id, type) {
      if (id == '') {
        id = 'create'
      }
      switch (type) {
        case 'short':
          this.$router.push({path: this.prefix + '/org/examQuestionShortAnswer/'+ id})
          break;
        case 'selection':
          this.$router.push({path: this.prefix + '/org/examQuestionChoice/'+ id})
          break;
        case 'write':
          this.$router.push({path: this.prefix + '/org/examQuestionCompletion/'+ id})
          break;
        case 'multiSelection':
          this.$router.push({path: this.prefix + '/org/examQuestionMultipleChoice/'+ id})
          break;
        case 'judgement':
          this.$router.push({path: this.prefix + '/org/examQuestionJudgment/'+ id})
          break;
      }
    },
    delQuestion (id) {
      this.$api.post(this.$global.examApiPath, '/examQuestion/delete', {id: id}, r => {
        this.getQuestions(this.filter)
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_question/list.vue